<form #previewForm="ngForm">
    <div class="row">
        <h6 *ngIf="!editPreview"><b>Preview {{letterType === 'COVLTR'? 'Cover Letter' : 'Support Letter'}}</b></h6>
        <h6 *ngIf="editPreview"><b>Edit {{letterType === 'COVLTR'? 'Cover Letter' : 'Support Letter'}}</b></h6>
    </div>
    <!-- | keepHtml -->
    <div [innerHtml]="previewLetter" class="mt-4 preview-comp" *ngIf='!editPreview'></div>
    <div class="mt-4" [hidden]='disabledControls || !editPreview'>
        <!-- <textarea spellcheck="true" [(froalaModel)]="previewLetter" name="coverLetterTextContent"
            [froalaEditor]="options" ngModel></textarea> -->
        <kendo-editor [(value)]="previewLetter" (valueChange)="previewLettereditorValueChange($event)"
            #previewkendoeditor style="height: 400px;" name="coverLetterTextContent">
            <kendo-toolbar>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                    <kendo-toolbar-button title="Upload’s Image at cursor point" text="Upload Image"
                        (click)="letterpreviewimageuploaddialog()"></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>

            </kendo-toolbar>
        </kendo-editor>
        <app-upload-image-dialog #previewimageupload [editor]="previewkendoeditor"></app-upload-image-dialog>
    </div>

    <div class="row col-md-12 dasheedTopBorder mt-3 pt-3 p-0">
        <div class="col-md-1 p-0">
            <a class="pull-left backContBtn" color="primary" (click)="backLink()">
                <i class="fa back-continue-icon fa-angle-left"></i>
            </a>
        </div>
        <div class="col-md-3 p-0">
            <button pButton type="button" label="Edit Letter" [disabled]="disabledControls"
                class="im-btn im-btn-primary im-btn-md" *ngIf="!editPreview" (click)="editPreviewPDF()"></button>
            <button pButton type="button" label="Save
        Changes" class="im-btn im-btn-primary im-btn-md" *ngIf="editPreview" (click)="savePreviewPDF()"></button>
        </div>
        <div class="col-md-3 p-0 text-right">
            <button [disabled]="disabledControls" class="im-btn im-btn-primary im-btn-md align-top"
                (click)="generatePDFFile()">Generate PDF</button>
        </div>
        <div class="col-md-4 p-0 justify-content-end text-right" *ngIf="!disabledControls">
            <button class="im-btn im-btn-primary im-btn-md" (click)="viewDocument()"
                *ngIf="isLastestLetterAvailable">View
                Document</button>
            <div *ngIf="isLastestLetterAvailable">
                <span class="hint-text"> Generated on {{latestLetterGeneratedOn}}</span>
            </div>
        </div>
        <div class="col-md-1 p-0">
            <a class="pull-right backContBtn" color="primary" (click)="nextLink()">
                <i class="fa back-continue-icon fa-angle-right"></i>
            </a>
        </div>
    </div>
</form>